import type {ZodType, z} from "zod/v4";

export abstract class BaseCollectionConfig<T extends ZodType, CollectionArgs> {
  protected constructor(protected schema: T) {}

  getCollectionPath(key: CollectionArgs): [string, ...string[]] {
    return this.getCollection(key) as [string, ...string[]];
  }

  getDocumentPath(key: CollectionArgs & {id?: string}): [string, ...string[]] {
    return [...this.getCollectionPath(key), key.id as string];
  }

  parseData(id: string, data: unknown): z.infer<T> {
    const parsed = this.parser(id, data);
    const res = this.schema.safeParse(parsed);
    if (res.success) return res.data;
    else {
      if (data !== undefined)
        console.error("Unable to parse data", data, res.error);
      throw new Error(`Unable to parse data ${res.error}`);
    }
  }

  mapForPersistence(data: z.infer<T>): any {
    return data;
  }

  protected abstract getCollection(
    key: CollectionArgs,
  ): [string, ...(string | undefined)[]];

  protected abstract parser(id: string, data: unknown): z.infer<T>;
}
